import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import Preloading from "../../../components/basics/Preloading";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";

const Product = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [measurements, setMeasurements] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [natureTypes, setNatureType] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: "",
    natureType: 0,
    productType: 0,
    code: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    natureType: 0,
    productType: 0,
    unitMeasurementId: 0,
    secondUnitMeasurementId: 0,
    description: "",
    categoryId: 0,
    branchId: branchId,
    takroSyncCode: "",
  });
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getGridData = async () => {
    const resp = await apiMethod.getProducts(
      filterModel.branchId,
      filterModel.productType,
      filterModel.natureType,
      filterModel.title,
      filterModel.code,
      filterModel.size,
      filterModel.part
    );
    if (!methods.showApiErrors(resp)) return false;
    setGridData(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getUnitMeasurements(
      filterModel.branchId,
      "",
      100,
      1
    );
    if (methods.showApiErrors(resp1)) setMeasurements(resp1.data);

    const resp2 = await apiMethod.getProductTypes();
    if (methods.showApiErrors(resp2)) setProductTypes(resp2.data);

    const resp3 = await apiMethod.getProductCategories(
      filterModel.branchId,
      "",
      100,
      1
    );
    if (methods.showApiErrors(resp3)) setProductCategories(resp3.data);

    const resp4 = await apiMethod.getNatureType();
    if (methods.showApiErrors(resp4)) setNatureType(resp4.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (formModel.branchId === 0) {
      errors.push(".ششناسه شعبه باید مقدار داشته باشد");
    }
    if (formModel.productType === 0) {
      errors.push(".نوع کالا باید مقدار داشته باشد");
    }
    if (formModel.categoryId === 0) {
      errors.push(".طبقه کالا باید مقدار داشته باشد");
    }
    if (formModel.unitMeasurementId === 0) {
      errors.push(".واحد سنجش باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.nature = "";
    formModel.productType = 0;
    formModel.unitMeasurementId = 0;
    formModel.secondUnitMeasurementId = 0;
    formModel.description = "";
    formModel.categoryId = 0;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = "";
    filterModel.code = "";
    filterModel.size = 20;
    filterModel.productType = 0;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    const resp = await apiMethod.getProductInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.natureType = resp.data.natureType;
    formModel.productType = resp.data.productType;
    formModel.unitMeasurementId = resp.data.unitMeasurementId;
    formModel.secondUnitMeasurementId = resp.data.secondUnitMeasurementId;
    formModel.takroSyncCode = resp.data.takroSyncCode;
    formModel.description = resp.data.description;
    formModel.categoryId = resp.data.categoryId;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const createNewItem = async () => {
    if (!validForm()) return false;

    setLoading(true);
    const resp = await apiMethod.createProduct(formModel);
    if (!methods.showApiErrors(resp)) return false;

    await getGridData();
    setShowFormModal(false);
    setLoading(false);
    return true;
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async (id) => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeProduct(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const searchItem = async () => {
    setLoading(true);
    filterModel.title = document.getElementById("searchInput").value;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const renderProduct = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/baseinfo/${branchId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/baseinfo/${branchId}`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                کالاها / خدمات
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                کالاها / خدمات
                <a
                  href={`/sale/${branchId}/softwareGuide/#section2`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-3 col-lg-3">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <label
                      htmlFor="productType"
                      className="form-label required-label"
                    >
                      نوع کالا
                    </label>
                    <select
                      id="productType"
                      className="form-select"
                      aria-label="Default select example"
                      value={filterModel.productType}
                      onChange={(e) => {
                        filterModel.productType = parseInt(e.target.value);
                        setFormModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>انتخاب کنید</option>
                      {productTypes.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-3 col-lg-">
                    <div className="mt-4 pt-2">
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          کالا جدید
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                {productCategories.length === 0 && (
                  <div className="my-5">
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(`/baseinfo/${branchId}/productcategory`);
                        }}
                      >
                        افزودن کالا
                      </button>
                    </div>
                  </div>
                )}
                {measurements.length === 0 && (
                  <div className="my-5">
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(`/baseinfo/${branchId}/unitmeasurements`);
                        }}
                      >
                        افزودن واحد سنجش
                      </button>
                    </div>
                  </div>
                )}
                {gridData.length !== 0 && (
                  <table className="table table-striped table-md ">
                    <thead className="align-middle">
                      <tr>
                        <th scope="col vertical-center" width="20px">
                          ردیف
                        </th>
                        <th scope="col vertical-center">عنوان</th>
                        <th scope="col vertical-center">کد کالا</th>
                        <th scope="col vertical-center">واحد اصلی</th>
                        <th scope="col vertical-center">
                          کد رابط کالای حسابداری
                        </th>
                        <th scope="col vertical-center">کد شعبه</th>
                        <th scope="col vertical-center">توضیحات</th>
                        <th scope="col vertical-center" width="100px">
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {gridData.map((item, index) => (
                        <tr key={item.id}>
                          <th scope="row">{index + 1}</th>
                          <td>{item.title}</td>
                          <td>{item.code}</td>
                          <td>{item.unitMeasurementTitle}</td>
                          <td>{item.takroSyncCode}</td>
                          <td>{item.branchId}</td>
                          <td>
                            {item.description.length > 10
                              ? item.description.slice(0, 30) + "..."
                              : item.description}
                          </td>
                          <td>
                            <button
                              onClick={() => editItem(item.id)}
                              className="btn btn-sm btn-outline-purple me-2"
                              type="button"
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            <button
                              onClick={() => selectَItemToDelete(item)}
                              className="btn btn-sm btn-outline-danger"
                              type="button"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const formModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش کالا</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowFormModal(false);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({ ...formModel, title: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="productType"
                    className="form-label required-label"
                  >
                    نوع کالا
                  </label>
                  <select
                    id="productType"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.productType}
                    onChange={(e) => {
                      formModel.productType = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        productType: formModel.productType,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {productTypes.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="category"
                    className="form-label required-label"
                  >
                    طبقه کالا
                  </label>
                  <select
                    id="category"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.categoryId}
                    onChange={(e) => {
                      formModel.categoryId = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        categoryId: formModel.categoryId,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {productCategories.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="category"
                    className="form-label required-label"
                  >
                    ماهیت کالا
                  </label>
                  <select
                    id="category"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.natureType}
                    onChange={(e) => {
                      formModel.natureType = parseInt(e.target.value);
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {natureTypes.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label">
                    کد رابط کالای حسابداری
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.takroSyncCode}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        takroSyncCode: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="unitMeasurement"
                    className="form-label required-label"
                  >
                    واحد سنجش اصلی
                  </label>
                  <select
                    id="unitMeasurement"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.unitMeasurementId}
                    onChange={(e) => {
                      formModel.unitMeasurementId = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        unitMeasurementId: formModel.unitMeasurementId,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {measurements.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="secondUnitMeasurement"
                    className="form-label required-label"
                  >
                    واحد سنجش فرعی
                  </label>
                  <select
                    id="secondUnitMeasurement"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.secondUnitMeasurementId}
                    onChange={(e) => {
                      formModel.secondUnitMeasurementId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={null}>انتخاب کنید</option>
                    {measurements.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    rows={3}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={() => {
                  setShowFormModal(false);
                }}
              >
                انصراف
              </button>
              <button
                onClick={() => {
                  createNewItem();
                }}
                type="button"
                className="btn custome-btn btn-purple w-50"
              >
                ثبت وذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderProduct()}
      {showFormModal && formModal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={"کالا"}
        />
      )}
    </>
  );
};

export default Product;
